import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../../web/components-v2/Theme/theme';
import { shadowMd } from '../../../../web/styles/shadows';

const { colors, typography, common } = THEME;

export const styleSheet = StyleSheet.create({
	selectTrigger: {
		background: colors.background.light,
		width: '100%',
	},
	input: {
		':nth-child(1n)': {
			background: 'none',
			border: 'none',
			color: colors.text.main,
			fontSize: typography.fontSizes.sm,
			marginLeft: THEME.space[8],
			outline: 'none',
			width: '100%',
		},
	},
	inputContainer: {
		alignItems: 'center',
		background: colors.background.light,
		border: `1px solid ${colors.border.main}`,
		borderRadius: common.borderRadius,
		boxSizing: 'border-box',
		display: 'flex',
		fontSize: typography.fontSizes.sm,
		height: THEME.space[36],
		paddingLeft: THEME.space[12],
		paddingRight: THEME.space[12],
		':focus-within': {
			borderColor: colors.primary.main,
		},
	},
	listHeader: {
		alignItems: 'center',
		display: 'flex',
		gap: THEME.space[16],
	},
	page: {
		display: 'flex',
		flexDirection: 'column',
		gap: THEME.space[16],
		maxWidth: 1000,
		width: '100%',
	},
	resultsContainer: {
		':nth-child(1n)': {
			background: colors.background.light,
			border: `1px solid ${colors.border.light}`,
			borderRadius: common.borderRadius,
			boxShadow: shadowMd,
			marginTop: THEME.space[4],
			padding: `${THEME.space[8]}px 0`,
			width: 560,
		},
	},
	searchIcon: {
		color: colors.icon.gray,
		flex: 'none',
		height: THEME.space[16],
		width: THEME.space[16],
	},
	searchField: {
		flex: 1,
		minWidth: 0,
	},
	searchFieldRoot: {
		width: '100%',
	},
	searchRow: {
		alignItems: 'center',
		display: 'flex',
		gap: THEME.space[16],
		[THEME.queries.md]: {
			alignItems: 'stretch',
			flexDirection: 'column',
		},
	},
	searchWrap: {
		flex: 1,
		minWidth: 0,
	},
	selectWrapper: {
		width: 220,
	},
	startABlitzContainer: {
		flex: 'none',
	},
	toEnd: {
		marginLeft: 'auto',
	},
	startABlitzIcon: {
		height: THEME.space[16],
		width: THEME.space[12],
	},
});
